import classNames from 'classnames'

import type {BuildId} from '../../../../types'
import BuildStateFilter from '../../../common/BuildStateFilter/BuildStateFilter'
import type {MatrixBuildFilter} from '../MatrixBuild.types'

import {useAvailableStates, useAvailableParameters} from './MatrixFilter.hooks'
import ParameterFilter from './ParameterValuesSelect/ParameterValuesSelect'

import styles from './MatrixFilter.css'

type MatrixFilterProps = MatrixBuildFilter & {
  className?: string
  buildId: BuildId
  currentStatuses?: Set<string>
}

function MatrixFilter({
  className,
  buildId,
  stateFilter,
  currentStatuses,
  parametersFilter,
  onChangeStateFilter,
  onChangeParametersFilter,
}: MatrixFilterProps) {
  const availibleStates = useAvailableStates()
  const availibleParameters = useAvailableParameters(buildId, stateFilter)

  return (
    <div className={classNames(className, styles.filter)}>
      <BuildStateFilter
        className={styles.state}
        activeState={stateFilter}
        states={availibleStates}
        currentStates={currentStatuses}
        onClick={onChangeStateFilter}
      />
      {availibleParameters?.map(param =>
        param.name != null && param.value != null ? (
          <div className={styles.parameters} key={param.name}>
            <ParameterFilter
              parameterName={param.name}
              data={param.value}
              selected={parametersFilter?.[param.name] ?? param.value.map(({value}) => value)}
              onChange={onChangeParametersFilter}
            />
          </div>
        ) : null,
      )}
    </div>
  )
}

export default MatrixFilter
